<template>
    <div :style="style">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        increaseBy: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        bold: String,
        bolder: String,
        color: String,
        spacing: Number,
        pointer: Boolean
    },
    computed: {
        style() {
            return {
                fontSize: 13 + this.increaseBy + 'px',
                fontWeight: (this.bold !== undefined && this.bolder ===undefined) ? 400 : (this.bolder) ? 500 : 300,
                color: this.color || 'inherit',
                margin: this.spacing + 'px',
                cursor: this.pointer ? 'pointer' : 'inherit'
            }
        }
    }
}
</script>